import ArrowDropDownIcon from '@/assets/icons/select-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiSelectStyles = {
    styleOverrides: {
        root: {
            backgroundColor: Palette.white,
            '& .MuiSelect-nativeInput': {
                backgroundColor: Palette.white,
            },
        },
        paper: {
            backgroundColor: Palette.white,
        },
    },
    defaultProps: {
        IconComponent: ArrowDropDownIcon,
    },
};
